import { useState, useEffect, useRef } from 'react';
import { getUserPreference, setUserPreference } from 'core/api/apiService';

/**
 * useVisibleFilters — verwaltet, welche Filter-Chips sichtbar sind, und merkt
 * die Auswahl PRO USER (user_preferences). So kann sich jeder Admin „seine"
 * Filter zusammenstellen.
 *
 * @param {Object} user
 * @param {string} storageKey   pref-Key, z. B. 'product-filter-fields'
 * @param {string[]} defaultKeys  Standard-Sichtbarkeit beim ersten Mal
 * @param {string[]} allKeys      gültige Keys (alte/ungültige werden verworfen)
 * @returns {[string[], (next:string[])=>void]}
 */
export default function useVisibleFilters(user, storageKey, defaultKeys, allKeys) {
  const [visible, setVisible] = useState(defaultKeys);
  const loaded = useRef(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const pref = await getUserPreference(user, storageKey);
        if (alive && pref && Array.isArray(pref.value)) {
          setVisible(pref.value.filter((k) => allKeys.includes(k)));
        }
      } catch (_e) {
        // keine Präferenz / Fehler -> Default behalten
      } finally {
        loaded.current = true;
      }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageKey]);

  const update = (next) => {
    setVisible(next);
    if (loaded.current && user) setUserPreference(user, storageKey, next).catch(() => {});
  };

  return [visible, update];
}
